<template>
  <!--begin::Layout-->
  <div v-if="operation" class="d-flex flex-column flex-lg-row">
    <!--begin::Content-->
    <div class="flex-lg-row-fluid me-lg-15 order-2 order-lg-1 mb-10 mb-lg-0">
      <Details :operation="operation" @edit="openEditDetails"></Details>

      <Invoices v-if="false"></Invoices>
    </div>
    <!--end::Content-->

    <!--begin::Sidebar-->
    <div
      class="
        flex-column flex-lg-row-auto
        w-lg-250px w-xl-300px
        mb-10
        order-1 order-lg-2
      "
    >
      <Summary :operation="operation"></Summary>
    </div>
    <!--end::Sidebar-->
    <NewOperation
      name="new-operation-modal"
      v-model="isNewOperationModalOpen"
      @cancel="closeEditDetails"
      @confirm="onOperationUpdated"
    >
      <template v-slot:title>Edit operation</template>
    </NewOperation>
  </div>
  <!--end::Layout-->
</template>

<script>
import Details from "@/components/operations/Details.vue";
import Events from "@/components/subscriptions/view/Events.vue";
import Invoices from "@/components/subscriptions/view/Invoices.vue";
import Summary from "@/components/operations/Summary.vue";
import NewOperation from "@/components/modals/operations/NewOperation.vue";
import { StickyComponent } from "@/assets/ts/components";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";

import ApiService from "@/core/services/ApiService";

export default {
  components: {
    Details,
    Invoices,
    Summary,
    NewOperation,
  },
  data() {
    return {
      isEditingDetails: false,
      operation: false,
      isNewOperationModalOpen: false,
    };
  },
  mounted() {
    this.fetchOperation();
    setCurrentPageBreadcrumbs("View Operation", [{ label: "Operations", to: '/operations' }]);
    this.$nextTick(() => {
      StickyComponent.reInitialization();
    });
  },
  methods: {
    openEditDetails() {
      this.$vfm.show("new-operation-modal", this.operation);
    },
    closeEditDetails() {
      this.isNewOperationModalOpen = false;
    },
    onOperationUpdated(updatedOperation) {
      this.$vfm.hide("new-operation-modal");
      this.fetchOperation();
    },
    fetchOperation() {
      ApiService
        .get('/operations', this.$route.params.id)
        .then(({ data }) => {
          console.log(data);
          this.operation = data;
        })
        .catch((err) => {
          // this.isTableLoading = false;
        });
    },
  },
};
</script>
